import { hotBoard } from "@/mocks/homeData";

const stateStyle: Record<string, string> = {
  登顶: "bg-red-600 text-white",
  引爆: "bg-orange-500 text-white",
  发酵: "bg-stone-200 text-stone-800",
  回落: "bg-stone-100 text-stone-500",
};

export default function HotBoard() {
  return (
    <section id="board" className="mx-auto max-w-[1440px] scroll-mt-4 px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-red-600">
            <i className="ri-bubble-chart-fill"></i> 热度榜单 · 醒目放送
          </div>
          <h2 className="mt-3 font-serif text-2xl font-black tracking-tight text-stone-900 md:text-4xl">
            今日正在上探的话题
          </h2>
          <p className="mt-2 text-sm leading-6 text-stone-500">
            按全网扩散速度与热度涨幅排序，热度越高，越接近热搜登顶引爆曲线。
          </p>
        </div>
        <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-red-600 hover:text-red-500">
          查看完整榜单 <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="mt-8 overflow-hidden rounded-lg border border-stone-200 bg-white">
        {hotBoard.map((item, idx) => (
          <div
            key={item.rank}
            className={`group grid grid-cols-[auto_1fr] items-center gap-4 px-4 py-4 transition-colors hover:bg-stone-50 md:grid-cols-[auto_1fr_auto] md:gap-6 md:px-6 ${
              idx !== hotBoard.length - 1 ? "border-b border-stone-100" : ""
            }`}
          >
            {/* 名次 */}
            <div className="flex w-10 flex-col items-center md:w-12">
              <span
                className={`font-serif text-3xl font-black leading-none ${
                  item.rank === 1 ? "text-red-600" : item.rank <= 3 ? "text-stone-800" : "text-stone-300"
                }`}
              >
                {String(item.rank).padStart(2, "0")}
              </span>
            </div>

            {/* 标题 */}
            <div>
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded bg-stone-100 px-1.5 py-0.5 text-[11px] font-semibold text-stone-500">
                  {item.tag}
                </span>
                <span className={`whitespace-nowrap rounded px-1.5 py-0.5 text-[11px] font-bold ${stateStyle[item.state]}`}>
                  {item.state}
                </span>
                <span className="text-xs font-bold text-red-600">{item.delta}</span>
              </div>
              <h3 className="mt-1.5 text-sm font-semibold leading-snug text-stone-800 md:text-base">{item.title}</h3>
            </div>

            {/* 热度与完成度 */}
            <div className="col-span-2 md:col-span-1 md:w-56">
              <div className="flex items-center justify-between text-[11px] text-stone-400">
                <span>热度 {item.heat}</span>
                <span>距登顶 {item.spread}%</span>
              </div>
              <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-stone-100">
                <div
                  className={`h-full rounded-full ${item.rank === 1 ? "bg-gradient-to-r from-red-600 to-orange-400" : "bg-stone-300"}`}
                  style={{ width: `${item.spread}%` }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}